const items = [
  { color: "bg-terracotta", text: "Audio pamokos" },
  { color: "bg-mustard", text: "Auginančios knygos" },
  { color: "bg-terracotta/60", text: "Žemėlapiai į save" },
  { color: "bg-ink", text: "Be reklamų, be prenumeratos" },
];


const ValueStrip = () => (
  <section className="bg-cream border-y hairline">
    <div className="container mx-auto px-6 py-6">
      <ul className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-8">
        {items.map((it) => (
          <li key={it.text} className="flex items-center gap-3 text-ink/85 text-sm md:text-base">
            <span className={`block w-3 h-3 rounded-full ${it.color}`} aria-hidden />
            <span>{it.text}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default ValueStrip;
